import React from "react";
import { Chip, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import { LabeledValue } from "../../../shared/LabeledValue";
import { SiteCommissioningSummary } from "../../../../dtos/siteCommissioning";
import { getHardwareFields } from "./hardwareConfigurationSummary";

const useStyles = makeStyles(() => ({
    chipRow: {
        display: "flex",
        flexWrap: "wrap",
        gap: "6px",
    },
}));

interface Props {
    summary?: SiteCommissioningSummary;
}

export const HardwareConfigurationSummaryFields: React.FC<Props> = ({ summary }) => {
    const classes = useStyles();
    const fields = getHardwareFields(summary);

    return (
        <>
            {fields.map((field) => (
                <LabeledValue
                    key={field.key}
                    label={field.label}
                    value={
                        field.value.kind === "chips" ? (
                            <span className={classes.chipRow}>
                                {field.value.items.map((item) => (
                                    <Chip key={item} size="small" label={item} />
                                ))}
                            </span>
                        ) : (
                            <Typography
                                variant="body2"
                                color={field.value.isPlaceholder ? "textSecondary" : "initial"}
                            >
                                {field.value.text}
                            </Typography>
                        )
                    }
                />
            ))}
        </>
    );
};
